module.exports = __webpack_public_path__ + "media/video-bg.e11b1a69.webm";